import { Controller } from 'stimulus'
import debounce from '../utils/debounce'

export default class extends Controller {
  initialize() {
    this._makeSpaceForFeatureBar = debounce(this.makeSpaceForFeatureBar.bind(this), 200)
    this.topBanner =
      document.getElementsByClassName('banner__wrap')[0] || document.getElementsByClassName('banner-home__wrap')[0]
  }
  makeSpaceForFeatureBar() {
    this.element.style.marginTop = `-${this.element.clientHeight}px`
    // add spacing to the first banner on the page, so that we don't get an ugly white bar at the top of the page before the feature bar slides in.
    if (!this.topBanner) return
    this.topBanner.style.marginTop = `${this.element.clientHeight}px`
  }

  connect() {
    this.makeSpaceForFeatureBar()
    window.addEventListener('resize', this._makeSpaceForFeatureBar)
    window.addEventListener('orientationchange', this._makeSpaceForFeatureBar)
  }

  disconnect() {
    window.removeEventListener('resize', this._makeSpaceForFeatureBar)
    window.removeEventListener('orientationchange', this._makeSpaceForFeatureBar)
  }
}
